import { cn } from '@goaltree/ui/lib/utils'
import { Flame, Snowflake } from 'lucide-react'

const inline = 'inline-block size-[1em] shrink-0 align-[-0.14em]'

export function StreakFlame({ className }: { className?: string }) {
  return (
    <Flame
      aria-hidden
      strokeWidth={2.25}
      className={cn(inline, 'text-[#ea580c] dark:text-[#ff6b35]', className)}
    />
  )
}

export function FreezeIcon({ className }: { className?: string }) {
  return (
    <Snowflake
      aria-hidden
      strokeWidth={2.25}
      className={cn(inline, 'text-blue-500 dark:text-blue-400', className)}
    />
  )
}
